/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createWatchListingUserInfo = /* GraphQL */ `
  mutation CreateWatchListingUserInfo(
    $input: CreateWatchListingUserInfoInput!
    $condition: ModelWatchListingUserInfoConditionInput
  ) {
    createWatchListingUserInfo(input: $input, condition: $condition) {
      id
      watchListing {
        id
        type
        title
        body
        url
        datetime
        sold
        thumbnail
        link_flair_text
        author_flair_text
        author
        created_timestamp
        price
        ttl
        createdAt
        updatedAt
      }
      userInfo {
        id
        collector
        email
        emailAcknowledged
        phone
        phoneAcknowledged
        phoneValidated
        phoneValidationCode
        stripe_customer
        weeklyTextCount
        weeklyEmailCount
        createdAt
        updatedAt
        owner
      }
      sim
      brand
      description
      notifyEmail
      notifyPhone
      subscriptionID
      ttl
      link_flair_text
      author
      author_flair_text
      postTitle
      createdAt
      updatedAt
      watchListingUserInfoWatchListingId
      watchListingUserInfoUserInfoId
    }
  }
`;
export const updateWatchListingUserInfo = /* GraphQL */ `
  mutation UpdateWatchListingUserInfo(
    $input: UpdateWatchListingUserInfoInput!
    $condition: ModelWatchListingUserInfoConditionInput
  ) {
    updateWatchListingUserInfo(input: $input, condition: $condition) {
      id
      watchListing {
        id
        type
        title
        body
        url
        datetime
        sold
        thumbnail
        link_flair_text
        author_flair_text
        author
        created_timestamp
        price
        ttl
        createdAt
        updatedAt
      }
      userInfo {
        id
        collector
        email
        emailAcknowledged
        phone
        phoneAcknowledged
        phoneValidated
        phoneValidationCode
        stripe_customer
        weeklyTextCount
        weeklyEmailCount
        createdAt
        updatedAt
        owner
      }
      sim
      brand
      description
      notifyEmail
      notifyPhone
      subscriptionID
      ttl
      link_flair_text
      author
      author_flair_text
      postTitle
      createdAt
      updatedAt
      watchListingUserInfoWatchListingId
      watchListingUserInfoUserInfoId
    }
  }
`;
export const deleteWatchListingUserInfo = /* GraphQL */ `
  mutation DeleteWatchListingUserInfo(
    $input: DeleteWatchListingUserInfoInput!
    $condition: ModelWatchListingUserInfoConditionInput
  ) {
    deleteWatchListingUserInfo(input: $input, condition: $condition) {
      id
      watchListing {
        id
        type
        title
        body
        url
        datetime
        sold
        thumbnail
        link_flair_text
        author_flair_text
        author
        created_timestamp
        price
        ttl
        createdAt
        updatedAt
      }
      userInfo {
        id
        collector
        email
        emailAcknowledged
        phone
        phoneAcknowledged
        phoneValidated
        phoneValidationCode
        stripe_customer
        weeklyTextCount
        weeklyEmailCount
        createdAt
        updatedAt
        owner
      }
      sim
      brand
      description
      notifyEmail
      notifyPhone
      subscriptionID
      ttl
      link_flair_text
      author
      author_flair_text
      postTitle
      createdAt
      updatedAt
      watchListingUserInfoWatchListingId
      watchListingUserInfoUserInfoId
    }
  }
`;
export const createUserWatchSubscriptionInfo = /* GraphQL */ `
  mutation CreateUserWatchSubscriptionInfo(
    $input: CreateUserWatchSubscriptionInfoInput!
    $condition: ModelUserWatchSubscriptionInfoConditionInput
  ) {
    createUserWatchSubscriptionInfo(input: $input, condition: $condition) {
      id
      brand
      description
      expiration
      expiration_datetime
      userinfoID
      notifyEmail
      notifyPhone
      searchField
      ttl
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateUserWatchSubscriptionInfo = /* GraphQL */ `
  mutation UpdateUserWatchSubscriptionInfo(
    $input: UpdateUserWatchSubscriptionInfoInput!
    $condition: ModelUserWatchSubscriptionInfoConditionInput
  ) {
    updateUserWatchSubscriptionInfo(input: $input, condition: $condition) {
      id
      brand
      description
      expiration
      expiration_datetime
      userinfoID
      notifyEmail
      notifyPhone
      searchField
      ttl
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteUserWatchSubscriptionInfo = /* GraphQL */ `
  mutation DeleteUserWatchSubscriptionInfo(
    $input: DeleteUserWatchSubscriptionInfoInput!
    $condition: ModelUserWatchSubscriptionInfoConditionInput
  ) {
    deleteUserWatchSubscriptionInfo(input: $input, condition: $condition) {
      id
      brand
      description
      expiration
      expiration_datetime
      userinfoID
      notifyEmail
      notifyPhone
      searchField
      ttl
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createWatchListing = /* GraphQL */ `
  mutation CreateWatchListing(
    $input: CreateWatchListingInput!
    $condition: ModelWatchListingConditionInput
  ) {
    createWatchListing(input: $input, condition: $condition) {
      id
      type
      title
      body
      url
      datetime
      sold
      thumbnail
      link_flair_text
      author_flair_text
      author
      created_timestamp
      price
      ttl
      createdAt
      updatedAt
    }
  }
`;
export const updateWatchListing = /* GraphQL */ `
  mutation UpdateWatchListing(
    $input: UpdateWatchListingInput!
    $condition: ModelWatchListingConditionInput
  ) {
    updateWatchListing(input: $input, condition: $condition) {
      id
      type
      title
      body
      url
      datetime
      sold
      thumbnail
      link_flair_text
      author_flair_text
      author
      created_timestamp
      price
      ttl
      createdAt
      updatedAt
    }
  }
`;
export const deleteWatchListing = /* GraphQL */ `
  mutation DeleteWatchListing(
    $input: DeleteWatchListingInput!
    $condition: ModelWatchListingConditionInput
  ) {
    deleteWatchListing(input: $input, condition: $condition) {
      id
      type
      title
      body
      url
      datetime
      sold
      thumbnail
      link_flair_text
      author_flair_text
      author
      created_timestamp
      price
      ttl
      createdAt
      updatedAt
    }
  }
`;
export const createUserInfo = /* GraphQL */ `
  mutation CreateUserInfo(
    $input: CreateUserInfoInput!
    $condition: ModelUserInfoConditionInput
  ) {
    createUserInfo(input: $input, condition: $condition) {
      id
      collector
      email
      emailAcknowledged
      phone
      phoneAcknowledged
      phoneValidated
      phoneValidationCode
      Subscriptions {
        nextToken
      }
      stripe_customer
      weeklyTextCount
      weeklyEmailCount
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateUserInfo = /* GraphQL */ `
  mutation UpdateUserInfo(
    $input: UpdateUserInfoInput!
    $condition: ModelUserInfoConditionInput
  ) {
    updateUserInfo(input: $input, condition: $condition) {
      id
      collector
      email
      emailAcknowledged
      phone
      phoneAcknowledged
      phoneValidated
      phoneValidationCode
      Subscriptions {
        nextToken
      }
      stripe_customer
      weeklyTextCount
      weeklyEmailCount
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteUserInfo = /* GraphQL */ `
  mutation DeleteUserInfo(
    $input: DeleteUserInfoInput!
    $condition: ModelUserInfoConditionInput
  ) {
    deleteUserInfo(input: $input, condition: $condition) {
      id
      collector
      email
      emailAcknowledged
      phone
      phoneAcknowledged
      phoneValidated
      phoneValidationCode
      Subscriptions {
        nextToken
      }
      stripe_customer
      weeklyTextCount
      weeklyEmailCount
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createAppInfo = /* GraphQL */ `
  mutation CreateAppInfo(
    $input: CreateAppInfoInput!
    $condition: ModelAppInfoConditionInput
  ) {
    createAppInfo(input: $input, condition: $condition) {
      notificationCount
      id
      createdAt
      updatedAt
    }
  }
`;
export const updateAppInfo = /* GraphQL */ `
  mutation UpdateAppInfo(
    $input: UpdateAppInfoInput!
    $condition: ModelAppInfoConditionInput
  ) {
    updateAppInfo(input: $input, condition: $condition) {
      notificationCount
      id
      createdAt
      updatedAt
    }
  }
`;
export const deleteAppInfo = /* GraphQL */ `
  mutation DeleteAppInfo(
    $input: DeleteAppInfoInput!
    $condition: ModelAppInfoConditionInput
  ) {
    deleteAppInfo(input: $input, condition: $condition) {
      notificationCount
      id
      createdAt
      updatedAt
    }
  }
`;
